import {useRef,useMemo} from "react";
import COMPONENT_MAP from '../Repository/Components.js';
import AnalysisReportVariableDrillPopup from './AnalysisReportVariableDrillPopup.js';

// PDF section 5 - the "Fix it with:" drill list under each fault.
const AnalysisReportVariableDrills=({parentId,application,userData,parent})=>{
    const list_name='analysis_report_variable_drills';
    const executeQuery=useRef(true);

    const renderListTab=useMemo(()=>{
        const Component=COMPONENT_MAP['ListTab'];
        return Component?(
            <Component
                parentId={parentId}
                parent={parent}
                application={application}
                userData={userData}
                entityType={'AnalysisReportVariableDrill'}
                entityParams={['analysis_report_variable_id='+parentId]}
                list_name={list_name}
                height={'50vh'}
                file={'AnalysisReportVariableDrills.js'}
                navigateOnNew={null}
                initialState={{}}
                checkboxSelection={true}
                disableRowSelectionOnClick={true}
                disableSelectionOnClick={true}
                popupComponent={AnalysisReportVariableDrillPopup}
                parentContext={{
                    parent_field_name:'analysis_report_variable_id',
                    parent_field_value:null,
                    parent_name:'AnalysisReportVariable',
                }}
                executeQuery={executeQuery}
            />
        ):null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[parentId,application.globalData.dataGridParams[list_name]]);

    return renderListTab;
}
export default AnalysisReportVariableDrills;
